module.exports = __webpack_public_path__ + "static/img/empty.922d3ced.png";